<template lang="pug">
  v-container
    v-row(justify="center")
      v-col(
        cols="12"
        md="11"
      )
        v-row.mx-0
          v-btn(
            text
            @click.stop="$router.push({ name: 'scholars' })"
          ).plain.pl-0
            v-icon(
              color="primary"
            ) mdi-chevron-left 
            h2 Back to List
          v-spacer
          v-btn(
            color="primary"
            @click.stop="submitDetails()"
            :loading="loading"
            :disabled="!validDetails"
          ).plain Submit
    v-row(justify="center")
      v-col(
        cols="12"
        md="11"
      )
        v-card(flat)
          v-card-text
            v-row.text-center
              v-col(
                cols="12"
                md="3"
              )
                v-tooltip(
                  bottom
                  v-if="!!img"
                )
                  template(#activator="{ on }")
                    img-cropper(
                      ref="imgCropperRef"
                      @done="cropped"
                      force-crop
                      :aspect-ratio="3/2"
                    )
                      template(slot="picker")
                        a(
                          v-on="on"
                          @click.stop="$refs.imgCropperRef.selectFile()"
                        )
                          v-card.pa-1
                            v-img(
                              :src="img"
                              :aspect-ratio="3/2"
                            )
                  span Upload Photo
                img-cropper(
                  ref="imgCropperRef"
                  @done="cropped"
                  force-crop
                  :aspect-ratio="3/2"
                  v-else
                )
                  template(slot="picker")
                    a(@click.stop="$refs.imgCropperRef.selectFile()")
                      v-card.pa-1
                        v-col(align-self="center")
                          v-icon mdi-camera
                          br
                          span Upload Photo
              v-col(
                cols="12"
                md="9"
              )
                v-form(
                  ref="details"
                  v-model="validDetails"
                )
                  v-row
                    v-col(
                      cols="12"
                      md="6"
                    ).pt-0
                      v-text-field(
                        label="First Name"
                        v-model="firstName"
                        clearable
                        outlined
                        :rules="firstNameRules"
                      )
                    v-col(
                      cols="12"
                      md="6"
                    ).pt-0
                      v-text-field(
                        label="Last Name"
                        v-model="lastName"
                        clearable
                        outlined
                        :rules="lastNameRules"
                      )
                  v-row
                    v-col(
                      cols="12"
                      sm="4"
                    ).pt-0
                      v-combobox(
                        v-model="ambition"
                        label="Ambition"
                        hint="Select or type the scholar's ambition"
                        filled
                        outlined
                        persistent-hint
                        :items="professions"
                        :filter="ambitionFilter"
                      ) 
                  v-textarea(
                    label="Story"
                    outlined
                    counter="168"
                    no-resize
                    :rules="storyShortRules"
                    v-model="storyShort"
                    placeholder="Place an introduction to the scholar..."
                  ).pt-2
                  v-textarea(
                    label="Bio"
                    outlined
                    auto-grow
                    :rules="bioRules"
                    v-model="storyLong"
                    placeholder="The full storyShort of the scholar..."
                  )
</template>

<script>
import placeholderImg from '@/assets/avatar-placeholder.png';
import { professions } from '../utils/dropdown-list';
import ImgCropper from '../components/commons/img-cropper';
import { firebaseStorage } from '../plugins/firebase';

export default {
  components: {
    ImgCropper
  },
  data () {
    return {
      placeholderImg,
      img: '',

      // details
      validDetails: false,
      firstName: '',
      firstNameRules: [
        v => !!v || 'First name is required'
      ],
      lastName: '',
      lastNameRules: [
        v => !!v || 'Last name is required'
      ],
      middleName: '',
      middleNameRules: [
        v => !!v || 'Middle name is required'
      ],
      ambition: '',
      ambitionRules: [
        v => !!v || 'Ambition is required'
      ],
      birthdate: '',
      birthdateRules: [
        v => !!v || 'Birthdate name is required'
      ],
      storyShort: '',
      storyShortRules: [
        v => !!v || 'Story is required',
        v => v.length <= 168 || 'Story should only be 168 characters or less'
      ],
      storyLong: '',
      bioRules: [
        v => !!v || 'Bio is required'
      ],
      loading: false,
      professions,
      ambitionFilter: (item, queryText, itemText) => item.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    };
  },
  methods: {
    async submitDetails () {
      if (this.validDetails) {
        this.loading = true;
        this.$setLoading(true);
        try {
          const beneficiary = await this.$store.dispatch('beneficiaries/create', {
            firstName: this.firstName,
            lastName: this.lastName,
            ambition: this.ambition,
            storyShort: this.storyShort,
            storyLong: this.storyLong,
            organizationId: this.$store.state.organization.organization.id,
            timeline: {
              title: 'Funding Started',
              body: 'Our scholar is ready to create a better future from your support.'
            }
          });
          if (this.img) {
            const storageRef = firebaseStorage.ref();
            const ref = storageRef.child(`mightyminds/beneficiaries/${beneficiary.id}/avatar.jpg`);
            await ref.putString(this.img, 'data_url');
            const picURL = await ref.getDownloadURL();
            await this.$store.dispatch('beneficiaries/update', { picURL, id: beneficiary.id });
          }

          this.$refs.details.resetValidation();
          this.$enqueueSnack('Scholar added');
          this.$router.push({ name: 'scholars' });
        } catch (error) {
          console.log(error);
          this.$enqueueSnack(error);
        } finally {
          this.loading = false;
          this.$setLoading(false);
        }
      }
    },
    async cropped (img) {
      this.img = img;
    }
  }
};
</script>